"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRefTagFromUrl = exports.REFTAG_REGEXES = exports.getAsinFromDetailPageUrl = exports.DETAIL_PAGE_URL_REGEXES = void 0;
exports.DETAIL_PAGE_URL_REGEXES = [
    new RegExp('(/[^/]*)?/dp/(?<asin>[^\\?]*)(?<queryParams>\\?.*)?'),
    new RegExp('/gp/aw/d/(?<asin>[^\\?]*)(?<queryParams>\\?.*)?'),
    new RegExp('/gp/aw/detail/(?<asin>[^\\?]*)(?<queryParams>\\?.*)?'),
    new RegExp('/gp/anywhere/d/(?<asin>[^\\?]*)(?<queryParams>\\?.*)?'),
    new RegExp('/gp/anywhere/detail/(?<asin>[^\\?]*)(?<queryParams>\\?.*)?')
];
const getAsinFromDetailPageUrl = (url) => {
    var _a, _b;
    if (!url) {
        return '';
    }
    for (const regex of exports.DETAIL_PAGE_URL_REGEXES) {
        const match = url.match(regex);
        if ((_a = match === null || match === void 0 ? void 0 : match.groups) === null || _a === void 0 ? void 0 : _a.asin) {
            return (_b = match === null || match === void 0 ? void 0 : match.groups) === null || _b === void 0 ? void 0 : _b.asin;
        }
    }
    return '';
};
exports.getAsinFromDetailPageUrl = getAsinFromDetailPageUrl;
exports.REFTAG_REGEXES = [
    new RegExp('ref-override=(?<refTag>[^\\?|&|/]*)'),
    new RegExp('(\\?|/|&)ref_=(?<refTag>[^\\?|&|/]*)'),
    new RegExp('(\\?|/|&)ref=(?<refTag>[^\\?|&|/]*)')
];
const getRefTagFromUrl = (url) => {
    var _a, _b;
    if (!url) {
        return '';
    }
    for (const regex of exports.REFTAG_REGEXES) {
        const match = url.match(regex);
        if ((_a = match === null || match === void 0 ? void 0 : match.groups) === null || _a === void 0 ? void 0 : _a.refTag) {
            return (_b = match === null || match === void 0 ? void 0 : match.groups) === null || _b === void 0 ? void 0 : _b.refTag;
        }
    }
    return '';
};
exports.getRefTagFromUrl = getRefTagFromUrl;
